import React from 'react';
import {
  DialogAction,
  DialogBody,
  DialogHeader,
  DialogHeaderAction,
  DialogStyled,
  DialogTitle,
} from './index.styled';
import { TDialog } from './index.types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const Dialog: React.FC<TDialog> = ({
                                     className,
                                     isDialogOpen,
                                     setIsDialogOpen,
                                     children,
                                     title,
                                     disableBackdropClick,
                                     dialogAction,
                                     closeButton = true,
                                     customHeaderAction,
                                   }) => {
  return (
    <DialogStyled
      className={className}
      onClose={() => setIsDialogOpen(false)}
      aria-labelledby="dialog"
      open={isDialogOpen}
      disableBackdropClick={disableBackdropClick}
    >
      <DialogHeader>
        {title ? <DialogTitle>{title}</DialogTitle> : <div></div>}
        <DialogHeaderAction>
          {customHeaderAction}
          {closeButton && (
            <IconButton onClick={() => setIsDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          )}
        </DialogHeaderAction>
      </DialogHeader>
      <DialogBody>{children}</DialogBody>
      {dialogAction && <DialogAction>{dialogAction}</DialogAction>}
    </DialogStyled>
  );
};

export default Dialog;
